import React from "react";
import { NavLink } from "react-router-dom";
import { Drawer, Box } from "@mui/material";
import { BsMenuUp } from "react-icons/bs";
import { LuLayoutDashboard } from "react-icons/lu";
import { MdAssignmentAdd } from "react-icons/md";



const Sidebar = ({ open, onClose }) => {
  const sidebarContent = (
    <Box
      sx={{
        width: 240,
        backgroundColor: "#1e272e",
        height: "100%",
        padding: "20px",
      }}
    >
      <div className="fw-bold mb-4 text-white"> <span className="me-1"> <BsMenuUp /> </span> Menu Items </div>
      <ul className="nav nav-pills flex-column mb-auto">
        <li className="nav-item">
          <NavLink
            to="dashboard"
            className={({ isActive }) =>
              `nav-link ${isActive ? "active text-white" : "text-white-50"}`
            }
          >
            <LuLayoutDashboard /> Dashboard
          </NavLink>
        </li>
        <li>
          <NavLink
            to="assigned-orders"
            className={({ isActive }) =>
              `nav-link ${isActive ? "active text-white" : "text-white-50"}`
            }
          >
            <MdAssignmentAdd /> Assigned Orders
          </NavLink>
        </li>
      </ul>
    </Box>
  );

  return (
    <>
      {/* Permanent sidebar on desktop */}
      <Box className="sidebar d-none d-md-block">{sidebarContent}</Box>

      {/* Drawer sidebar on mobile */}
      <Drawer anchor="left" open={open} onClose={onClose} sx={{ display: { md: "none" } }}>
        {sidebarContent}
      </Drawer>
    </>
  );
};

export default Sidebar;
